import React, { FC } from 'react';

import styles from './index.module.scss';

interface StatusBarItemCursorPosition {
	positionInM: number | undefined;
}

export const StatusBarItemCursorPosition: FC<StatusBarItemCursorPosition> = ({ positionInM }) => (
	<div className={styles.item} data-statusbar-item-type="menu-cursor-position">
		@ <span className={styles.length}>{positionInM?.toFixed(2) ?? '-.--'}m</span>
	</div>
);
